import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ListModule } from '@portal-core/ui/list/list.module';
import { LicenseUserProjectsListComponent } from './license-user-projects-list.component';


@NgModule({
  declarations: [
    LicenseUserProjectsListComponent
  ],
  imports: [
    CommonModule,
    ListModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    IncludedInModule,
    MatSnackBarModule,
    ProjectAvatarModule,
    MatTooltipModule
  ],
  exports: [
    LicenseUserProjectsListComponent
  ]
})
export class LicenseUserProjectsListModule { }
